export const getYearLabel = (date: string) => {
  if (date.toString().indexOf('-') !== -1) {
    const [startYear] = date.split('-');
    const fullStartYear = parseInt(startYear, 10);
    const fullEndYear = parseInt(startYear, 10) + 1;
    return `${fullStartYear}-${fullEndYear}`;
  }
  return `${Number(date) - 1}-${date}`;
};
